<template>
  <b-form-select :id="safeId()" v-model="localValue" :options="options" text-field="label"
                 value-field="pictureId"></b-form-select>
</template>

<script>
  export default {
    name: 'picture-select',
    props: ['value', 'albumId'],
    data () {
      return {
        localValue: this.value
      }
    },
    computed: {
      options () {
        const album = this.$store.getters.album(this.albumId)
        if (!album) return []
        const options = album.pictures.map(p => ({
          pictureId: p.pictureId,
          label: p.fileName
        }))
        options.sort((a, b) => {
          if (a.label < b.label) return -1
          if (a.label > b.label) return 1
          return 0
        })
        return [{label: '', pictureId: null}].concat(options)
      }
    },
    watch: {
      localValue: function (val) {
        this.$emit('input', val)
      },
      value: function (val) {
        this.localValue = val
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/picture-select.vue